import React from 'react';
import { Tabs } from 'tea-component';
import { ITabOption } from '../../type';
import './index.scss';

export interface ITabsHeaderProps {
  tabs: ITabOption[];
  activeId: string;
  onChange: (id: string) => void;
}

const TabsHeader: React.FC<ITabsHeaderProps> = (props) => {
  const { tabs, activeId, onChange } = props;

  if (!tabs || tabs.length === 0) {
    return null;
  }

  return (
    <div className="dbh-transfer-modal-tabs-header">
      <Tabs
        tabs={tabs}
        activeId={activeId}
        onActive={(tab) => onChange(tab.id)}
      />
    </div>
  );
};

export default TabsHeader;
